export * as appPlans from '@wix/auto_sdk_app-management_app-plans/meta';
export * as appInstances from '@wix/auto_sdk_app-management_app-instances/meta';
export * as appPermissions from '@wix/auto_sdk_app-management_app-permissions/meta';
export * as biEvents from '@wix/auto_sdk_app-management_bi-events/meta';
export * as billing from '@wix/auto_sdk_app-management_billing/meta';
export * as embeddedScripts from '@wix/auto_sdk_app-management_embedded-scripts/meta';
export * as externalBilling from '@wix/auto_sdk_app-management_external-billing/meta';
